"use client";
import * as React from "react";
const SvgLightbulbOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 11 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M3.14 15.2c0 .44.36.8.79.8h3.14a.8.8 0 0 0 .79-.8v-.8H3.14zM5.5 0a5.63 5.63 0 0 0-3.14 10.2V12c0 .44.35.8.78.8h4.72a.8.8 0 0 0 .78-.8v-1.8A5.6 5.6 0 0 0 11 5.6C11 2.51 8.53 0 5.5 0m2.24 8.88-.67.48v1.84H3.93V9.36l-.67-.48A4 4 0 0 1 1.57 5.6c0-2.2 1.76-4 3.93-4s3.93 1.8 3.93 4a4 4 0 0 1-1.7 3.28Z" }));
export {
  SvgLightbulbOutlined as default
};
